import { customerHelper } from '@tweddle-se-team/common/constants'

const { CUSTOMER_IDS } = customerHelper

const navigationOptions = {
  admin: [
    {
      name: 'Digital First',
      route: '/admin/digitalFirst'
    },
    {
      name: 'Users',
      route: '/admin/users'
    },
    {
      name: 'Localization',
      route: '/admin/translations'
    },
    {
      name: 'Configuration',
      route: '/admin/config'
    },
    {
      name: 'MM Visibility',
      route: '/admin/config/publicationVisibilityMM',
      customerIds: [CUSTOMER_IDS.TME]
    },
    {
      name: 'Publication drafts',
      route: '/admin/publication-draft'
    },
    {
      name: 'Workers',
      route: '/admin/workers'
    },
    {
      name: 'Dashboard',
      route: '/admin/dashboard'
    },
    {
      name: 'Analytics',
      route: '/admin/analytics',
      customerIds: [CUSTOMER_IDS.TME]
    },
    {
      name: 'Change Log',
      route: '/admin/changelog'
    }
  ]
}

export default navigationOptions
